import ttiPolyfill from 'tti-polyfill'

export default async function getTTI(): Promise<any> {
  return ttiPolyfill.getFirstConsistentlyInteractive()
}
